<template>
    <v-container class="pa-0" fluid>
        <v-card class="pa-2">
            <v-card-title class="pt-0 pb-2 justify-center"><h2>Conversation Details</h2></v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <p class="text-center">A conversation with "{{ conversation.metadata.assistant }}"</p>
            </v-card-text>
            <v-divider></v-divider>
            <v-row class="pa-4">
                <v-btn class="primary" small @click="askQuestion" :disabled="disableExport">
                    <span>Ask a question</span>
                </v-btn>
                <v-spacer></v-spacer>
                <span class="pl-4">
                    <v-btn class="primary" small @click="buildReport" :disabled="disableExport" color="success">
                        <v-icon small class="pr-2">mdi-microsoft-excel</v-icon>
                        <span>Export</span>
                    </v-btn>
                </span>                
            </v-row>
            <v-divider></v-divider>
            <v-row>
                <v-col cols="6" class="pt-2 pb-6"><v-text-field v-model="search" label="Search conversation" single-line hide-details prepend-icon="mdi-magnify"></v-text-field></v-col>
            </v-row>
            <v-divider></v-divider>
            <v-data-table 
                :items="conversation.messages" 
                :items-per-page="10" 
                :footer-props="{'items-per-page-options': [10, 50, 100, 200, -1]}"
                :headers="headers"
                :search="search">
                <template v-slot:item="props">
                    <tr>
                        <td>{{ props.item.role }}</td>
                        <td>{{ props.item.created_date }}</td>
                        <td><longTextView :long_text="props.item.full_text" :max_width="800"/></td>
                        <td>
                            <v-btn class="primary" small @click="runDetails(props.item)" v-if="props.item.role==='assistant'">
                                <span>Details</span>
                            </v-btn>
                             <!-- <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn 
                                        x-small 
                                        text 
                                        v-bind="attrs" 
                                        v-on="on"
                                        v-on:click="runDetails(props.item)"
                                        
                                        color="primary"
                                        >
                                        Details
                                    </v-btn>
                                </template>
                                <span>Mark as duplicate</span>
                            </v-tooltip> 
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn 
                                        x-small 
                                        text icon 
                                        v-bind="attrs" 
                                        v-on="on"
                                        v-on:click="setToAssign(props.item)"
                                        class="button-margin-lr gridbutton">
                                        <v-icon small color="green">mdi-account-check-outline</v-icon>
                                    </v-btn>
                                </template>
                                <span>Mark as not a duplicate</span>
                            </v-tooltip> 
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn 
                                        x-small 
                                        text icon 
                                        v-bind="attrs" 
                                        v-on="on"
                                        v-on:click="assignPtenLead(props.item)"
                                        class="button-margin-lr gridbutton">
                                        <v-icon small>mdi-account-plus-outline</v-icon>
                                    </v-btn>
                                </template>
                                <span>Assign lead <br> (not a duplicate)</span>
                            </v-tooltip>  -->
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-card>
        <cardQuestionAdd ref="cardQuestionAdd" @updateData="updateData"/>
        <showProgress ref="showProgress"/>
    </v-container>
</template>

<script>
    import longTextView from "@/components/ui/fields/longTextView.vue";
    import showProgress from "@/components/showProgress.vue";

    // import cardWait from "@/components/syst/openai/cardWait.vue";
    import cardQuestionAdd from "@/components/syst/openai/cardQuestionAdd.vue";

    export default {
        components: {
            longTextView,
            showProgress,
            // cardWait,
            cardQuestionAdd,
        },
        props: {
            conversation: {
                required: true,
            },
        },
        data() {
            return {
                disableExport: false,

                search: "",

                headers: [
                    {text: 'Sender',  value: 'role', width: "100px", tdClass: 'align-text-top' },
                    {text: 'Created', value: 'created_date', width: "150px", tdClass: 'align-text-top'},
                    {text: 'Message', value: 'full_text', width: "800px", tdClass: 'align-text-top'},
                    {text: 'Actions', value: '', width: "50px", tdClass: 'align-text-top'},
                ],
            }
        },
        mounted() {
        },
        methods: {
            actionClick(action) {
                switch (action) {
                    case "refresh":
                        //this.getDetailAccommodation();
                        break;
                }
            },
            updateData(data) {
                this.$emit("updateData", data);
            },
            runDetails(item) {
                this.$router.open("/syst/openai/conversationRuns/" + this.conversation.id + "/" + item.run_id);
            },
            askQuestion () {
                this.$refs.cardQuestionAdd.openDialog(this.conversation);
            },
            buildReport() {
                this.disableExport = true;
                this.$refs.showProgress.open();
                this.$axios.post("ares/json/ares/syst/openai/excelExportConversation.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "excelExportConversation"
                    },
                    excelExportConversation: {
                        items: this.conversation.messages,
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        window.open(res.data.excelExportConversation.filename, '_blank');
                    }
                    this.$refs.showProgress.close();
                    this.disableExport = false;
                });
            },
        }
    };
</script> 

<style scoped>
    .align-text-top {
        vertical-align: top;
    }
</style>
